import { NavLink } from 'react-router-dom';
import { footerLinks } from '../../utils/constants';
import styles from './navFooter.module.css';

export const Footer = () => {
  return (
    <footer className={styles.footer}>
      <span className={styles.navbarDivider}></span>
      <nav className={styles.footerLinks}>
        <div>
          <a
            className={styles.footerLink}
            href="https://armory.teidore.com"
            rel="noopener noreferrer">
            TEIDORE ARMORY
          </a>
        </div>
        {footerLinks.map((link) => (
          <div key={link.name}>
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? `${styles.footerLink} ${styles.footerLinkSelected}`
                  : styles.footerLink
              }
              to={link.path}>
              {link.name}
            </NavLink>
          </div>
        ))}
      </nav>
      <span className={styles.navbarDivider}></span>
      <p>&copy; {new Date().getFullYear()} TEIDORE, LLC. All rights reserved.</p>
    </footer>
  );
};